import httpClient from 'shared/utils/http-client'
import { CourseId } from '../types/course-interface'
import { LectureId, LectureInterface } from '../types/lecture-interface'
import { LightModuleInterface, ModuleId } from '../types/module-interface'

export const LIGHT_COURSE_API = '/api/dashboard/customer/membership/light-editor/course'

export const getLightCourseCurriculumPath = (courseId: CourseId) =>
  `${LIGHT_COURSE_API}/${courseId}/curriculum`

export const LIGHT_COURSES_LIST_ALL_API = `/api/dashboard/customer/membership/courses/light/list-all`

export const CREATE_LIGHT_COURSE_API = `${LIGHT_COURSE_API}/create`

export const getLightCoursePatchOptionsPath = (courseId: CourseId) =>
  `${LIGHT_COURSE_API}/${courseId}/options`

export const getLightCourseCreateModulePath = (courseId: CourseId) =>
  `${LIGHT_COURSE_API}/${courseId}/create-module`

export const getLightCourseCreateLecturePath = (moduleId: ModuleId) =>
  `/api/dashboard/customer/membership/light-editor/module/${moduleId}/create-lecture`

export const getLightCourseUpdateLecturePath = (lectureId: LectureId) => {
  return `/api/dashboard/customer/membership/light-editor/lecture/${lectureId}`
}

export const getLightCourseDeleteLecturePath = (lectureId: LectureId) => {
  return `/api/dashboard/customer/membership/light-editor/lecture/${lectureId}`
}

export const getLightCourseGetLecturePath = (lectureId: LectureId) => {
  return `/api/dashboard/customer/membership/light-editor/lecture/${lectureId}`
}

export const getLightCourseUpdateModulePath = (moduleId: ModuleId) => {
  return `/api/dashboard/customer/membership/light-editor/module/${moduleId}`
}

export const moveModule = (
  id: ModuleId,
  data: { course: CourseId; salesFunnelStep: number | null },
) =>
  httpClient.post<LightModuleInterface>(
    `/api/membership/secure/label/courses/light/module/${id}/move`,
    data,
  )

export const moveLecture = (id: LectureId, data: { course: CourseId; module: ModuleId }) =>
  httpClient.post<LectureInterface>(
    `/api/membership/secure/label/courses/light/lecture/${id}/move`,
    data,
  )
